__turbopack_context__.v({
  "date": "index-module__9LkYAa__date",
  "formationItem": "index-module__9LkYAa__formationItem",
  "formation_items": "index-module__9LkYAa__formation_items",
});
